import { useEffect, useState } from "react";
import Step from "./Step";
import TransactionsTable from "../TransactionsTable"; import Transactions from "../Transactions";

export default function AboutTransfers({ index }) {
  const [transaction, setTransaction] = useState(null);
  const [counterpart, setCounterpart] = useState(null);
  useEffect(() => {
    fetch("/api/on_ramp/example_data")
      .then(response => response.json())
      .then(data => {
        setTransaction(data.transactions.transfer);
        setCounterpart(data.transactions.transfer_counterpart);
      });
  }, []);

  if (!transaction) return "";
  return <Step title="Internal Transfers" index={index} canProceed>
    <p>
      Not all transactions are spending. Some transactions are transfers between
      own accounts. When you are moving money from one account to another, we will
      categorize this as an <strong>Internal Transfer</strong> and will not
      count it as spending.
    </p>
    <p>
      When we are connected to your credit card accounts, Payments to your credit card are
      also transfers, and are not counted as spending. If we do not yet have acess to your
      credit card or loan accounts, we will categorize these as spending.
    </p>
    <p>
      Here's an example of two transactions, that are actually two parts of the same
      transfer:
    </p>
    <TransactionsTable transactions={[transaction, counterpart]}
      columns={["account_name"]} />
    <p>
      Sometimes transfers are hard to detect. For example, we sometimes see transfers
      via a check between two accounts that you own. The two transactions may be recorded
      on different dates.
    </p>
    <p>
      We may miss some transfers, and miscategorize some transactions as spending and assign
      them to a Payee and Category. Fortunately, it is easy to mark a Payee as an internal
      transfer to correct this.
    </p>
  </Step>
}